
import React from 'react';
import { BacktestHistoryWidget } from './BacktestHistoryWidget';
import { SPYChart } from './charts/SPYChart';

export const RiskAlertsDashboard = () => {
  return (
    <div className="space-y-6">
      <BacktestHistoryWidget />

      {/* Expanded SPY Chart */}
      <SPYChart height="700px" />
    </div>
  );
};
